// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1TkRr","rootMobile":"styles_rootMobile__1B_nJ"};